








































































































































































import dayjs from 'dayjs';
// import {getEmployeeList,enableOrDisableEmployee} from '@/api/employee'
// import {getClienteleList, deleteClientele} from '@/api/clientele'
// import {getOrderNumber} from '@/api/consultant'
// import {getStus, delStu} from '@/api/student'
import {getReceipts, exportReceipt, getYears, getTransctionsInfo, delReceipts} from '@/api/receipts_consultant'
import {queryConsultantById} from '@/api/consultant'
import router from '@/router';

import { Loading } from 'element-ui'
export default  {
  //模型数据
  data() {
    return {
      consultantName: '', // 咨询师姓名
      loading: false,

      // stuName: '',
      // amount: '',
      // total: '',
      // year: '',
      // chargeDate: '',
      // chargeDeadlineDate: '',
      // bz: '',
      // createTime: '',
      // updateTime: '',

      name: '', // 学生姓名，对应上面的输入框
      year: '', // 年份
      yearOptions: [],
      transYear: '',
      transClientleNumber: 0,// 成交总人数
      transMoneyNumber: 0,// 成交总金额
      returnMoneyNumber: 0, // 回款总金额
      // transInfo: {
      //
      // },

      page: 1, //页码
      pageSize: 10, //每页记录数
      total: 0, //总记录数
      records: [], //当前页要展示的数据集合
      multipleSelection: [],
      // orderNumber: 0 //客单数
      selectedReceiptId: '', // 选中收据id
      selectedStuName: '',

      dialogVisible: false, // 控制弹出框显示
      form: {
        template: 0, // 选择的模板
      },
      templates: [
        { label: "展览馆校区专用", value: 0},
        { label: "明泽校区专用", value: 1 },
        { label: "包四中专用", value: 2 },
      ],
    }
  },
  created() {
    // this.CheckMac()
    // this.getConsultantOrderNumber()
    //
    // /*
    // let month = new Date().getMonth()
    // if(month<9)  this.year = new Date().getFullYear()
    // else this.year = new Date().getFullYear() + 1
    // */
    this.year = this.$route.query.year
    this.pageQuery()
    this.getYearOptions()
    this.getConsultantName()

  },
  methods: {

    getConsultantName(){
      const consultantId = this.$route.query.consultantId
      queryConsultantById(consultantId).then(res => {
        if(res.data.code === 1){
          this.consultantName = res.data.data.name
        }
      })
    },

    getYearOptions(){
      const params = {consultantId: this.$route.query.consultantId}
      getYears(params).then( res => {
        if(res.data.code === 1){
          this.yearOptions = res.data.data
        }else{
          this.$message.warning("年份加载失败，请刷新页面重试")
        }

      })
    },
    getTransInfo(){

      const params = {
        year: this.year,
        consultantId: this.$route.query.consultantId
      }
      getTransctionsInfo(params).then( res => {
        if(res.data.code === 1){
          this.transYear = this.year + '年'
          this.transClientleNumber = res.data.data.transClientleNumber
          this.transMoneyNumber = res.data.data.transMoneyNumber
          this.returnMoneyNumber = res.data.data.returnMoneyNumber
        }else{
          this.$message.warning("交易信息加载失败，请刷新页面重试")
        }
      })

    },

    formatDate(row, column, cellValue) {
      return dayjs(cellValue).format('YYYY-MM-DD');
    },


    //分页查询
    pageQuery() {

      // alert("pageQuery")
      // this.$message.info("正在加载中...")
      this.loading = true
      //准备请求参数
      const params = {
        consultantId: this.$route.query.consultantId,
        stuName: this.name,
        year: this.year,
        page: this.page,
        pageSize: this.pageSize
      }
      //发送Ajax请求，访问后端服务，获取分页数据
      getReceipts(params).then(res => {
        if(res.data.code === 1) {
          this.total = res.data.data.total
          this.records = res.data.data.records
        }
      }).catch(err => {
        this.$message.error('请求出错了：' + err.message)
      })
      this.loading = false
      // 获取交易信息
      this.getTransInfo()
      this.$message.success("数据获取成功！")
    },
    //pageSize发生变化时触发
    handleSizeChange(pageSize) {
      this.pageSize = pageSize
      this.pageQuery()
    },
    //page发生变化时触发
    handleCurrentChange(page) {
      this.page = page
      this.pageQuery()
    },

    async exportPDF(receiptId, departmentId, StuName){
      // alert(666)
      if (this.form.template==null) {
        this.$message.error("请选择模板！");
        return;
      }
      this.$message.success(`您选择了模板：${this.templates[this.form.template].label}`);
      // async  () => {
        const loadingInstance = Loading.service({
          lock: true,
          text: '正在导出中，请稍候...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
        });
        const params = {
          departmentId: departmentId,
        }

        // let studentName = row.stuName
        // exportReceipt(row.id)
        const { data } = await exportReceipt(receiptId, params)
        let url = window.URL.createObjectURL(data)
        var a = document.createElement('a')
        document.body.appendChild(a)
        a.href = url
        a.download = StuName + "收据.pdf"
        a.click()
        window.URL.revokeObjectURL(url)

        // 关闭加载提示
        loadingInstance.close();
        this.$message({
          type: 'success',
          message: '导出成功！',
        });
      this.dialogVisible = false; // 关闭弹出框
      // }
    },
// -----------------------------------------------
    openDialog(row) {
      this.selectedReceiptId = row.id
      this.selectedStuName = row.stuName
      this.dialogVisible = true; // 打开弹出框
    },
    confirm() {
      if (this.form.template==null) {
        this.$message.error("请选择模板！");
        return;
      }
      this.$message.success(`您选择了模板：${this.templates[this.form.template].label}`);
      this.exportPDF(this.selectedReceiptId, this.form.template, this.selectedStuName)
      this.dialogVisible = false; // 关闭弹出框
    },
    resetForm() {
      this.form.template = 0; // 重置表单
    },

    updateReceipt(row){
      // this.selectedReceiptId = row.id
      // this.$router.push("/receipts/consultantReceipt?consultantId="+consultantId)
      this.$router.push("/receipts/updateReceipt?receiptId="+row.id+"&consultantId="+this.$route.query.consultantId)
    },

    // -----------------------------------------------

    // --------------------------
    //跳转到新增员工页面（组件）
    handleAddReceipt(){
      //路由跳转，跳转到新增员工组件
      this.$router.push('/receipts/addReceipt')
    },

    //跳转到修改员工页面（组件）
    handleUpdateClientele(row) {

      //跳转到修改页面，通过地址栏传递参数
      this.$router.push({
        path: '/simulation/addStu',
        query: {id: row.id}
      })
    },
    handlePlanClientele(row){
      //跳转到规划页面，通过地址栏传递参数
      this.$router.push({
        path: '/consultantDashboard/addPlan',
        query: {clienteleId: row.id}
      })
    },
    handleCurrentPlanClientele(row){
      //跳转到规划页面，通过地址栏传递参数
      this.$router.push({
        path: '/simulation/simGroup',
        query: {stuId: row.id, stuName: row.stuName}
      })
    },

    // 多选客单
    handleSelectionChange(val) {
      this.multipleSelection = val

      console.log('当前表格勾选了几项：' + val.length)
      // val.forEach(element => {
      //   console.log('id=' + element.id)
      // })
    },
    // 删除客单
    handleDelete() {
      if(this.multipleSelection.length===0) {
        this.$message.warning("未选中收据！")
      }else{
        this.$confirm('即将删除选中收据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const receiptIdList = []


          this.multipleSelection.forEach(element => {
            receiptIdList.push(element.id)
          })

          const params = {receiptIds: receiptIdList.join(',')}
          delReceipts(params).then(res => {
            if(res.data.code === 1){
              this.$message.success('删除成功！')
              this.pageQuery()
            }else{
              this.$message.error('删除失败，请重试！')
            }
          })


          // this.$router.go(0);

        })
      }

    },
  }
}
